<template>
  <span class="info-tooltip">
    <button
      type="button"
      class="info-tooltip-button btn border-0 bg-transparent p-0"
      :aria-label="text"
      :aria-describedby="tooltipId"
    >
      <i class="bi bi-info-circle" aria-hidden="true"></i>
    </button>
    <span :id="tooltipId" class="info-tooltip-text" role="tooltip">
      {{ text }}
    </span>
  </span>
</template>

<script setup lang="ts">
import { useId } from "vue";

defineProps<{
  text: string;
}>();

const tooltipId = `info-tooltip-${useId()}`;
</script>

<style scoped>
.info-tooltip {
  align-items: center;
  display: inline-flex;
  position: relative;
}

.info-tooltip-button {
  align-items: center;
  display: inline-flex;
  height: 1.5rem;
  line-height: 1;
}

.info-tooltip-button .bi::before {
  vertical-align: 0;
}

.info-tooltip-text {
  background: var(--bs-dark);
  border-radius: var(--bs-border-radius);
  color: var(--bs-white);
  display: none;
  left: 50%;
  max-width: min(24rem, 80vw);
  padding: 0.5rem 0.75rem;
  position: absolute;
  top: calc(100% + 0.25rem);
  transform: translateX(-50%);
  width: max-content;
  z-index: 10;
}

.info-tooltip:hover .info-tooltip-text,
.info-tooltip:focus-within .info-tooltip-text {
  display: block;
}
</style>
